import React from "react";

// Original C&M monogram — sage tile, cream italic ampersand, ochre register mark
export default function CMMark({ className = "h-8 w-8" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label="Charis & Mettle monogram"
    >
      <rect width="64" height="64" fill="#2F443B" />
      <text
        x="31"
        y="45"
        textAnchor="middle"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontStyle="italic"
        fontSize="38"
        fill="#F9F8F6"
      >
        &amp;
      </text>
      <rect x="45" y="11" width="9" height="9" fill="#C89B3C" />
    </svg>
  );
}
